import apiClient from "@/utils/apiClient";

/* ============================
   ITINERARY SEARCH
============================ */

export const getItineraryOptions = (
  query
) => {

  return apiClient.get(
    `/quotations/itinerary/options`,
    {
      params: { query },
    }
  );
};

/* ============================
   HOTEL SEARCH
============================ */

export const searchHotels = (
  query = "",
  travelDate = null,
  leadId = null,
  destinations = null
) => {

  return apiClient.get(
    `/quotations/search-hotels`,
    {
      params: {
        query,
        travelDate,
        leadId,
        destinations,
      },
    }
  );
};

/* ============================
   ROUTE SEARCH
============================ */

export const searchTransportRoutes = (
  query = "",
  leadId = null,
  destinations = null
) => {

  return apiClient.get(
    `/transport-plan/search`,
    {
      params: {
        query,
        leadId,
        destinations,
      },
    }
  );
};

/* ============================
   PREVIEW PRICING
============================ */

export const previewQuotation = (
  data
) => {

  return apiClient.post(
    `/quotations/preview-pricing`,
    data
  );
};

/* ============================
   CREATE QUOTATION
============================ */

export const createQuotation = (
  data
) => {

  return apiClient.post(
    `/quotations`,
    data
  );
};

/* ============================
   UPDATE QUOTATION
============================ */

export const updateQuotation = (
  quotationId,
  data
) => {

  return apiClient.put(
    `/quotations/${quotationId}`,
    data
  );
};

/* ============================
   GET QUOTATION
============================ */

export const getQuotation = (
  quotationId
) => {

  return apiClient.get(
    `/quotations/${quotationId}`
  );
};

/* ============================
   DUPLICATE QUOTATION
============================ */

export const duplicateQuotation = (
  quotationId
) => {

  return apiClient.post(
    `/quotations/${quotationId}/duplicate`
  );
};

/* ============================
   CANCEL QUOTATION
============================ */

export const cancelQuotation = (
  quotationId
) => {

  return apiClient.patch(
    `/quotations/${quotationId}/cancel`
  );
};

/* ============================
   ARCHIVE QUOTATION
============================ */

export const archiveQuotation = (
  quotationId
) => {

  return apiClient.patch(
    `/quotations/${quotationId}/archive`
  );
};

/* ============================
   CONVERT TO BOOKING
============================ */
export const convertQuotationToBooking = (
  quotationId
) => {

  return apiClient.post(
    "/bookings/convert",
    {
      quotationId,
    }
  );
};

/* ============================
   SEND PROPOSAL
============================ */

export const sendQuotationProposal = (
  quotationId,
  data
) => {

  return apiClient.post(
    `/quotations/${quotationId}/send`,
    data
  );
};

/* ============================
   GET ACTIVE OFFERS
============================ */

export const getActiveOffers = () => {

  return apiClient.get(
    `/offers/active`
  );
};

/* ============================
   RESERVE OFFER
============================ */

export const reserveOffer = (
  data
) => {

  return apiClient.post(
    `/offers/reserve-offer`,
    data
  );
};

/* ============================
   DOWNLOAD QUOTATION PDF
============================ */

export const downloadQuotationPdf = (
  quotationId
) => {

  return apiClient.get(
    `/quotations/${quotationId}/pdf`,
    {
      responseType: "blob",
      timeout: 0,
      bypassCache: true,
    }
  );
};
